import PromoCampaignCreationSecondLine from './PromoCampaignCreationSecondLine'

export default PromoCampaignCreationSecondLine
